import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

var _templateObject;

import styled from 'styled-components';
import { rem } from 'polished';
import { authTheme } from '@luigiclaudio/ga-baseline-ui/auth';
import { media } from '@luigiclaudio/ga-baseline-ui/layout';
var MailchimpSubscribeFeatureDescription = styled.div.withConfig({
  displayName: "MailchimpSubscribeFeatureDescription",
  componentId: "sc-13mr3fj-0"
})(["margin:0 auto;max-width:", ";padding-bottom:", ";padding-top:", ";position:relative;width:100%;", ""], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'auth.container.maxWidth', authTheme.auth.container.maxWidth));
}, rem(16), rem(16), media.sm(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        max-width: none;\n        padding-right: ", ";\n        padding-top: 0;\n        width: auto;\n    "])), rem(16)));
export default MailchimpSubscribeFeatureDescription;